import {
  TiVoAcrRights,
  TiVoCspBizModel,
  TiVoCspGroup,
  TiVoLaunchType,
  TiVoPresentationAttributes,
} from "hooks/tivoApps";

/*
 * Constants
 */
export const PAGE_LIMIT = 20;

export const MAIN_ROUTE = "tivoapps";

export const DEFAULT_PATHS = {
  APP_DETAILS: "application",
  VARIANT_DETAILS: "variant",
  APP_FORM: "base",
  VARIANT_FORM: "launch",
};

export const PATHS = {
  createProvider: `/${MAIN_ROUTE}/create/:tabId`,
  createVariant: `/${MAIN_ROUTE}/create/:id/variant/:tabId`,
  detailsProvider: `/${MAIN_ROUTE}/details/:id/:tabId`,
  detailsVariant: `/${MAIN_ROUTE}/details/:id/variant/:variantId/:tabId`,
  editProvider: `/${MAIN_ROUTE}/edit/:id/:tabId`,
  editVariant: `/${MAIN_ROUTE}/edit/:id/variant/:variantId/versions/:versionId/:tabId`,
};

export const VARIANT_DRAFT_ID = "draft";

/*
 * Enums
 */

export enum IMAGES {
  PRIMARY_BRANDING_LOGO_SQUARE = "primaryBrandingLogoSquare",
  PARTNER_SOURCE_LOGO_SQUARE = "partnerSourceLogoSquare",
  PARTNER_SOURCE_LOGO_WIDE = "partnerSourceLogoWide",
  PRIMARY_BRANDING_LOGO_RECTANGLE = "primaryBrandingLogoRectangle",
  ATMOSPHERIC = "atmospheric",
}

export enum IMAGE_ENVS {
  STAGING = "staging",
  PROD = "prod",
}

export enum PRESENTATION_BOOLEAN {
  off = "Off",
  inherited = "Inherited",
  on = "On",
}

export const PRESENTATION_BOOLEAN_KEYS: (keyof TiVoPresentationAttributes)[] = [
  "alwaysVisibleInMyApps",
  "appManifestAvailable",
  "enabledByDefault",
  "inMyAppsByDefault",
  "promoted",
  "shouldShowInList",
  "shouldShowInSearchInApps",
  "supportsEpisodeDeepLinks",
];

/*
 * Labels
 */

export const ACR_RIGHTS_LABELS: Record<TiVoAcrRights, string> = {
  yes: "Yes",
  no: "No",
  notMentioned: "Not mentioned",
};

export const CSP_BIZ_MODEL_LABELS: Record<TiVoCspBizModel, string> = {
  fast: "Fast linear",
  avod: "AVOD",
  svod: "SVOD",
  tvod: "TVOD",
  unmonetized: "Unmonetized",
  vmvpd: "vMVPD",
};

export const CSP_GROUP_LABELS: Record<TiVoCspGroup, string> = {
  global_t1: "Global T1",
  global_t2: "Global T2",
  local_t1: "Local T1",
  local_t2: "Local T2",
  other_premium: "Other Premium",
  long_tail: "Long Tail",
};

export const IMAGE_LABELS: Record<IMAGES, string> = {
  primaryBrandingLogoSquare: "Square logo (solid background)",
  partnerSourceLogoSquare: "Square logo (transparent background)",
  partnerSourceLogoWide: "Wide logo (transparent background)",
  primaryBrandingLogoRectangle: "Rectangular logo (solid background)",
  atmospheric: "Rectangular logo (transparent background)",
};

export const LAUNCH_TYPE_LABELS: Record<TiVoLaunchType, string> = {
  launch: "Launch",
  linear: "Linear",
  searchLaunch: "Search launch",
  seriesBrowse: "Series browse",
  vod: "VOD",
};

export const PRESENTATION_ATTRIBUTES_LABELS: Record<
  keyof TiVoPresentationAttributes,
  string
> = {
  appManifestAvailable: "App Manifest Available",
  alwaysVisibleInMyApps: "Always visible in my apps",
  browsePlaybackSortOrder: "Browse playback sort order",
  enabledByDefault: "Enabled by default",
  inMyAppsByDefault: "In my apps by default",
  myAppsRangeGroup: "My apps range group",
  name: "App name",
  platformSupportedApps: "Platform supported apps",
  promoted: "Promoted",
  postPublishDaysConsideredNew: "Post-publish days considered new",
  publishDateTime: "Publish Date",
  recommendationsType: "Recommendation type",
  shouldShowInList: "Should show in list",
  shouldShowInSearchInApps: "Should show in search in apps",
  sortOrder: "Sort order",
  supportsEpisodeDeepLinks: "Supports episode deep links",
};
